(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filtrare-pdp-rewards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filtrare-pdp-rewards')) {
    customElements.define('filtrare-pdp-rewards', class extends HTMLElement {
      connectedCallback() {
        if (this.viewport) return;
        const product = this.closest('product-info');
        if (!product) return;
        this.desktopSlot = product.querySelector('[data-filtrare-rewards-desktop]');
        this.mobileSlot = product.querySelector('[data-filtrare-rewards-mobile]');
        this.viewport = window.matchMedia('(max-width: 749px)');
        this.place = () => {
          const destination = this.viewport.matches ? this.mobileSlot : this.desktopSlot;
          if (destination && this.parentElement !== destination) destination.append(this);
        };
        this.viewport.addEventListener('change', this.place);
        this.place();
        const widget = this.querySelector('.essential-spend-tier-bar');
        this.syncProgress = () => {
          const fill = widget.querySelector('[data-essential-cart-element="reward-progress-bar-fill"]');
          const count = widget.querySelectorAll('[data-essential-cart-element="reward-milestone"]').length;
          if (!fill || !count) return;
          const source = fill.style.getPropertyValue('--width').trim();
          if (!source.endsWith('%')) return;
          const progress = Math.min(1, Math.max(0, parseFloat(source) / 100));
          if (!Number.isFinite(progress)) return;
          const first = 1 / count;
          const mapped = progress >= 1 ? 1 : progress <= first ? progress / 2 : progress - first / 2;
          this.style.setProperty('--filtrare-progress', (mapped * 100) + '%');
        };
        this.progressObserver = new MutationObserver(this.syncProgress);
        this.progressObserver.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'aria-label'] });
        this.syncProgress();
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected || !this.viewport) return;
          this.viewport.removeEventListener('change', this.place);
          this.viewport = null;
          this.progressObserver?.disconnect();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
